import { PricingCard } from "./PricingCard";
export default PricingCard;
